import styled from 'styled-components'

const Main = styled.div``

export default {
    Main,
}
